"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const global_1 = require("../global");
const fov_models_1 = require("./fov-models");
const lodash_1 = require("lodash");
const fov_errors_1 = require("./fov-errors");
class FovNodes {
    static get(type) {
        switch (type) {
            case fov_models_1.FovNodeTypes.AND:
                return this.andGroup();
            case fov_models_1.FovNodeTypes.OR:
                return this.orGroup();
            case fov_models_1.FovNodeTypes.SEQ:
                return this.sequenceGroup();
            case fov_models_1.FovNodeTypes.FILTER:
                return this.filter(fov_models_1.FovFieldTypes.GoalId);
            default:
                return this.andGroup();
        }
    }
    static sequenceGroup(...children) {
        return {
            children,
            nodeType: fov_models_1.FovNodeTypes.SEQ,
        };
    }
    static orGroup(...children) {
        return {
            children,
            nodeType: fov_models_1.FovNodeTypes.OR,
        };
    }
    static andGroup(...children) {
        return {
            children,
            nodeType: fov_models_1.FovNodeTypes.AND,
        };
    }
    static blankGroup(...children) {
        return {
            children,
            nodeType: fov_models_1.FovNodeTypes.AND,
        };
    }
    static not(child) {
        return {
            child,
            nodeType: fov_models_1.FovNodeTypes.NOT,
        };
    }
    static filter(field, operator = global_1.ComparisonOperators.MATCH_EQUALS, value = null) {
        return {
            field,
            operator,
            value,
            nodeType: fov_models_1.FovNodeTypes.FILTER,
        };
    }
    static isGroup(node) {
        if (!node) {
            return false;
        }
        return Object.values(fov_models_1.FovGroupTypes).includes(node.nodeType);
    }
    static isNotGroup(node) {
        if (!node) {
            return false;
        }
        return node.nodeType === fov_models_1.FovNodeTypes.NOT;
    }
    static isFilter(node) {
        if (!node) {
            return false;
        }
        return node.nodeType === fov_models_1.FovNodeTypes.FILTER;
    }
    static isEmptyFov(node) {
        return !node || lodash_1.isEqual(node, fov_models_1.FOV_EMPTY) || lodash_1.isEqual(node, fov_models_1.FOV_ALL_VISITORS);
    }
    static createFovFromSegmentIds(includedSegmentIds, excludedSegmentIds) {
        const includedSegments = [];
        const excludedSegments = [];
        if (includedSegmentIds && includedSegmentIds.length) {
            for (const includedSegmentId of includedSegmentIds) {
                if (includedSegmentId === global_1.ALL_VISITORS) {
                    continue;
                }
                includedSegments.push({
                    nodeType: fov_models_1.FovNodeTypes.FILTER,
                    field: fov_models_1.FovFieldTypes.SegmentId,
                    operator: global_1.ComparisonOperators.MATCH_EQUALS,
                    value: includedSegmentId,
                });
            }
        }
        if (excludedSegmentIds && excludedSegmentIds.length) {
            for (const excludedSegmentId of excludedSegmentIds) {
                if (excludedSegmentId === global_1.ALL_VISITORS) {
                    throw new fov_errors_1.FovError(`FOV.BUILDER`, `Cannot exclude segments all visitors.`);
                }
                excludedSegments.push({
                    nodeType: fov_models_1.FovNodeTypes.FILTER,
                    field: fov_models_1.FovFieldTypes.SegmentId,
                    operator: global_1.ComparisonOperators.MATCH_NOT_EQUALS,
                    value: excludedSegmentId,
                });
            }
        }
        return FovNodes.andGroup(...includedSegments, ...excludedSegments);
    }
}
exports.FovNodes = FovNodes;
//# sourceMappingURL=fov-nodes.js.map